<template>
  <div class="wrap">
    <header>
      <span class="iconfont icon-back-left" @click="goBack"></span>
    </header>
    <div class="indexWrap">
      <div class="login-wrap">
        <p class="title">{{lang.changepassword}}</p>
        <label><input type="password" v-model.trim="pwdOld" :placeholder="lang.enoldpass"></label>
        <label><input type="password" v-model.trim="pwdNew" :placeholder="lang.ennewpass"></label>
        <label><input type="password" v-model.trim="pwdNewS" :placeholder="lang.ennewpassAgain"></label>
        <p class="btn" @click="submit">{{lang.confirm}}</p>
      </div>    
    </div>
  </div>
</template>
<script type="text/javascript">
  import {mapState} from 'vuex';
  export default {
    data() {
      return {
        type:'',
        pwdOld: '',
        pwdNew: '',
        pwdNewS:''
      }
    },
    computed: {
			...mapState(['lang'])
		},
    created(){
      this.type = this.$route.query.type || 'login';
      this.pwdOld =  '';
      this.pwdNew = '';
      this.pwdNewS = '';
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      submit() {
        if(this.pwdNew!=this.pwdNewS){
          this.$messagebox(this.lang.tip, this.lang.noSame);
          return false;
        }
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/user/chgPwd',{
          type:this.type,
          pwdOld:this.pwdOld,
          pwdNew:this.pwdNew
        }).then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.$toast({
                message: res.data.msg,
                iconClass: 'iconfont icon-chenggong'
              })
              setTimeout(()=>{
                this.$router.push('My')
              },3000)
            }else{
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$router.push('/');
          })
      },
    },
  }
</script>
<style type="text/css"  scoped>
  header {
    background: #fff;

    .icon-back-left {
      color: #333;
    }
  }

  .indexWrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 44px;
    bottom: 0;
    background: #fff;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
  }

  .login-wrap {
    padding: 20px;
  }

  .login-wrap .title {
    font-size: 24px;
  }

  .login-wrap label {
    display: flex;
    align-items: center;
    height: 40px;
    margin-top: 15px;
    border-bottom: 1px solid #ddd;
  }

  .login-wrap label input {
    flex: 1;
    height: 30px;
  }

  .login-wrap .untie {
    color: rgba(4, 15, 66, 0.6);
    padding: 15px 0;
    font-size: 12px;
  }

  .login-wrap .untie>span,
  .getCode {
    padding: 10px 0;
    color: rgb(231, 76, 60);
  }

  .login-wrap .btn {
    margin: 30px 30px 0;
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    border-radius: 20px;
    font-size: 16px;
    background: #3476FE;
  }
</style>